var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NxInput',{attrs:{"name":"siglaUFOrgaoExpeditor","type":"text","label":"Sigla UF do Orgao Expeditor:","placeholder":"Digite a sigla","maxlength":3,"value":_vm.localValue,"isDisabled":_vm.isDisabled},on:{"update:value":_vm.handleValueUpdate}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96b650c0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nexum/components/custom-inputs/NxInputSiglaUFOrgaoExpeditor.vue
// module id = null
// module chunks = 